import { createRouter, createWebHistory } from 'vue-router';
import Login from '@/views/Login.vue';
import MobileNo from '@/views/MobileNo.vue';
import VerifyOtp from '@/views/VerifyOtp.vue';

// const OnboardingType = () =>
//   import(
//     /* webpackChunkName: "OnboardingType" */ '@/views/OnboardingType.vue'
//   );
const Dashboard = () =>
  import(
    /* webpackChunkName: "Dashboard" */ '@/views/Dashboard.vue'
  );
const Success = () =>
  import(
    /* webpackChunkName: "Success" */ '@/views/Success.vue'
  );
const Failure = () =>
  import(
    /* webpackChunkName: "Failure" */ '@/views/Failure.vue'
  );
// const Tnc = () =>
//   import(
//     /* webpackChunkName: "Tnc" */ '@/views/Tnc.vue'
//   );
// const ServiceabilityCheck = () =>
//   import(
//     /* webpackChunkName: "ServiceabilityCheck" */ '@/views/ServiceabilityCheck.vue'
//   );
// const BusinessRegistration = () =>
//   import(
//     /* webpackChunkName: "BusinessRegistration" */ '@/views/BusinessRegistration.vue'
//   );
const LinkAccounts = () =>
  import(
    /* webpackChunkName: "LinkAccounts" */ '@/views/LinkAccounts.vue'
  );
const LinkedAccounts = () =>
  import(
    /* webpackChunkName: "LinkedAccounts" */ '@/views/LinkedAccounts.vue'
  );
// const BusinessProfile = () =>
//   import(
//     /* webpackChunkName: "BusinessProfile" */ '@/views/BusinessProfile.vue'
//   );
// const PersonalProfileStep1 = () =>
//   import(
//     /* webpackChunkName: "PersonalProfileStep1" */ '@/views/PersonalProfileStep1.vue'
//   );
// const PersonalProfileStep2 = () =>
//   import(
//     /* webpackChunkName: "PersonalProfileStep2" */ '@/views/PersonalProfileStep2.vue'
//   );
const AdditionalInfo = () =>
  import(
    /* webpackChunkName: "AdditionalInfo" */ '@/views/AdditionalInfo.vue'
  );
// const ViewProfile = () =>
//   import(
//     /* webpackChunkName: "ViewProfile" */ '@/views/ViewProfile.vue'
//   );
const LoanOffers = () =>
  import(
    /* webpackChunkName: "LoanOffers" */ '@/views/LoanOffers.vue'
  );
const LoanAgreement = () =>
  import(
    /* webpackChunkName: "LoanAgreement" */ '@/views/LoanAgreement.vue'
  );
const LoanSuccess = () =>
  import(
    /* webpackChunkName: "LoanSuccess" */ '@/views/LoanSuccess.vue'
  );
const LoanFailure = () =>
  import(
    /* webpackChunkName: "LoanFailure" */ '@/views/LoanFailure.vue'
  );
const SignupUnderReview = () =>
  import(
    /* webpackChunkName: "SignupUnderReview" */ '@/views/SignupUnderReview.vue'
  );
const AdditionalDocuments = () =>
  import(
    /* webpackChunkName: "AdditionalDocuments" */ '@/views/AdditionalDocuments.vue'
  );
const DualNameDeclaration = () =>
  import(
    /* webpackChunkName: "DualNameDeclaration" */ '@/views/DualNameDeclaration.vue'
  );
const DualDobDeclaration = () =>
  import(
    /* webpackChunkName: "DualDobDeclaration" */ '@/views/DualDobDeclaration.vue'
  );
const BankDetails = () =>
  import(
    /* webpackChunkName: "BankDetails" */ '@/views/BankDetails.vue'
  );
const UploadDocuments = () =>
  import(
    /* webpackChunkName: "UploadDocuments" */ '@/views/UploadDocuments.vue'
  );
const Home = () =>
  import(
    /* webpackChunkName: "Home" */ '@/views/Home.vue'
  );
const MyProfile = () =>
  import(
    /* webpackChunkName: "MyProfile" */ '@/views/MyProfile.vue'
  );
const GSTINVerification = () =>
  import(
    /* webpackChunkName: "GSTINVerification" */ '@/views/GSTINVerification.vue'
  );
const NachMandate = () =>
  import(
    /* webpackChunkName: "NachMandate" */ '@/views/NachMandate.vue'
  );
const UploadPreview = () =>
  import(
    /* webpackChunkName: "UploadPreview" */ '@/views/UploadPreview.vue'
  );
const Signup = () =>
  import(
    /* webpackChunkName: "Signup" */ '@/views/Signup.vue'
  );
const Mandate = () =>
  import(
    /* webpackChunkName: "Mandate" */ '@/views/Mandate.vue'
  );
const BankStatement = () =>
  import(
    /* webpackChunkName: "BankStatement" */ '@/views/BankStatement.vue'
  );
const Questionnaire = () =>
  import(
    /* webpackChunkName: "Questionnaire" */ '@/views/Questionnaire.vue'
  );
const PaymentHistory = () =>
  import(
    /* webpackChunkName: "PaymentHistory" */ '@/views/PaymentHistory.vue'
  );
const Rewards = () =>
  import(
    /* webpackChunkName: "Rewards" */ '@/views/Rewards.vue'
  );

const RewardStatement = () =>
  import(
    /* webpackChunkName: "RewardStatement" */ '@/views/RewardStatement.vue'
  );
const ReferAndEarn = () =>
  import(
    /* webpackChunkName: "ReferAndEarn" */ '@/views/ReferAndEarn.vue'
  );
const MyCards = () =>
  import(
    /* webpackChunkName: "MyCards" */ '@/views/MyCards.vue'
  );
const MandateSuccess = () =>
  import(
    /* webpackChunkName: "MandateSuccess" */ '@/views/MandateSuccess.vue'
  );
const MandateAlreadyCompleted = () =>
  import(
    /* webpackChunkName: "MandateAlreadyCompleted" */ '@/views/MandateAlreadyCompleted.vue'
  );
const NACHSuccess = () =>
  import(
    /* webpackChunkName: "NACHSuccess" */ '@/views/NACHSuccess.vue'
  );
const MandateFailure = () =>
  import(
    /* webpackChunkName: "MandateFailure" */ '@/views/MandateFailure.vue'
  );
const MandatePending = () =>
  import(
    /* webpackChunkName: "MandatePending" */ '@/views/MandatePending.vue'
  );
// const KycSelection = () =>
//   import(
//     /* webpackChunkName: "KycSelection" */ '@/views/KycSelection.vue'
//   );
// const Selfie = () =>
//   import(
//     /* webpackChunkName: "Selfie" */ '@/views/Selfie.vue'
//   );
const KycSuccess = () =>
  import(
    /* webpackChunkName: "KycSuccess" */ '@/views/KycSuccess.vue'
  );
const KycFailure = () =>
  import(
    /* webpackChunkName: "KycFailure" */ '@/views/KycFailure.vue'
  );
const KycResult = () =>
  import(
    /* webpackChunkName: "KycResult" */ '@/views/KycResult.vue'
  );
const LoanAutoActivation = () =>
  import(
    /* webpackChunkName: "LoanAutoActivation" */ '@/views/LoanAutoActivation.vue'
  );
const ApplicationDiscrepancy = () =>
  import(
    /* webpackChunkName: "ApplicationDiscrepancy" */ '@/views/ApplicationDiscrepancy.vue'
  );
const PayNow = () =>
  import(
    /* webpackChunkName: "PayNow" */ '@/views/PayNow.vue'
  );
const QuickPayment = () =>
  import(
    /* webpackChunkName: "QuickPayment" */ '@/views/QuickPayment.vue'
  );
const UploadInvoice = () =>
  import(
      /* webpackChunkName: "UploadInvoice" */ '@/views/UploadInvoice.vue'
  );
const MakeInvoicePayment = () =>
  import(
      /* webpackChunkName: "MakeInvoicePayment" */ '@/views/MakeInvoicePayment.vue'
  );
const QuickPaymentOTP = () =>
  import(
      /* webpackChunkName: "QuickPaymentOTP" */ '@/views/QuickPaymentOTP.vue'
  );
const QuickPaymentSuccess = () =>
  import(
        /* webpackChunkName: "QuickPaymentSuccess" */ '@/views/QuickPaymentSuccess.vue'
  );
const QuickPaymentFail = () =>
  import(
      /* webpackChunkName: "QuickPaymentFail" */ '@/views/QuickPaymentFail.vue'
  );
const PaymentMethods = () =>
  import(
    /* webpackChunkName: "PaymentMethods" */ '@/views/PaymentMethods.vue'
  );
  const ProcessingFee = () =>
    import(
      /* webpackChunkName: "ProcessingFee" */ '@/views/ProcessingFeeComponent.vue'
    );
    const ProcessingFeeResult = () =>
      import(
        /* webpackChunkName: "ProcessingFeeResult" */ '@/views/ProcessingFeeResult.vue'
      );
const PaymentSuccess = () =>
  import(
    /* webpackChunkName: "PaymentSuccess" */ '@/views/PaymentSuccess.vue'
  );
const PaymentFailure = () =>
  import(
    /* webpackChunkName: "PaymentFailure" */ '@/views/PaymentFailure.vue'
  );
const TransactionSummary = () =>
  import(
    /* webpackChunkName: "TransactionSummary" */ '@/views/TransactionSummary.vue'
  );
// const ReferralInfo = () =>
//   import(
//     /* webpackChunkName: "ReferralInfo" */ '@/views/ReferralInfo.vue'
//   );
const VideoVerification = () =>
  import(
    /* webpackChunkName: "VideoVerification" */ '@/views/VideoVerification.vue'
  );
const LoanDetails = () =>
  import(
    /* webpackChunkName: "LoanDetails" */ '@/views/LoanDetails.vue'
  );
const ErrorNotEligible = () =>
import(
  /* webpackChunkName: "ErrorNotEligible" */ '@/views/ErrorNotEligible.vue'
);
const TransactionDetails = () =>
  import(
    /* webpackChunkName: "TransactionDetails" */ '@/views/TransactionDetails.vue'
  );
const Suppliers = () =>
  import(
    /* webpackChunkName: "Suppliers" */ '@/views/Suppliers.vue'
  );
const Offers = () =>
  import(
    /* webpackChunkName: "Offers" */ '@/views/Offers.vue'
  );

const OfferDetails = () =>
  import(
    /* webpackChunkName: "OfferDetails" */ '@/views/OfferDetails.vue'
  );

const SupplierPaymentHistory = () =>
  import(
    /* webpackChunkName: "SupplierPaymentHistory" */ '@/views/SupplierPaymentHistory.vue'
  );
const SupplierPendingPayments = () =>
  import(
    /* webpackChunkName: "SupplierPendingPayments" */ '@/views/SupplierPendingPayments.vue'
  );
const SelectSupplier = () =>
  import(
    /* webpackChunkName: "SelectSupplier" */ '@/views/SelectSupplier.vue'
  );
const PendingRequests = () =>
  import(
    /* webpackChunkName: "PendingRequests" */ '@/views/PendingRequests.vue'
  );
const SupplierParent = () =>
  import(
    /* webpackChunkName: "SupplierParent" */ '@/views/SupplierParent.vue'
  );
const AddSupplier = () =>
  import(
    /* webpackChunkName: "AddSupplier" */ '@/views/AddSupplier.vue'
  );
const PendingPaymentDetails = () =>
  import(
    /* webpackChunkName: "PendingPaymentDetails" */ '@/views/PendingPaymentDetails.vue'
  );
const ClearPaymentDue = () =>
  import(
    /* webpackChunkName: "ClearPaymentDue" */ '@/views/ClearPaymentDue.vue'
  );
const InviteSupplier = () =>
  import(
    /* webpackChunkName: "InviteSupplier" */ '@/views/InviteSupplier.vue'
  );
const SendInviteSupplier = () =>
  import(
    /* webpackChunkName: "SendInviteSupplier" */ '@/views/SendInviteSupplier.vue'
  );
const PrePostApprovalLayout = () =>
  import(
    /* webpackChunkName: "PrePostApprovalLayout" */ '@/views/PrePostApprovalLayout.vue'
  );
const PreApprovalStep1 = () =>
  import(
    /* webpackChunkName: "PreApprovalStep1" */ '@/views/PreApprovalStep1.vue'
  );
const PreApprovalStep2 = () =>
  import(
    /* webpackChunkName: "PreApprovalStep2" */ '@/views/PreApprovalStep2.vue'
  );
const PreApprovalStep3 = () =>
  import(
    /* webpackChunkName: "PreApprovalStep3" */ '@/views/PreApprovalStep3.vue'
  );
const PreApprovalKycSelection = () =>
  import(
    /* webpackChunkName: "PreApprovalKycSelection" */ '@/views/PreApprovalKycSelection.vue'
  );
const PreApprovalReview = () =>
  import(
    /* webpackChunkName: "PreApprovalReview" */ '@/views/PreApprovalReview.vue'
  );
const PreApprovalCongratulations = () =>
  import(
    /* webpackChunkName: "PreApprovalCongratulations" */ '@/views/PreApprovalCongratulations.vue'
  );
const PreApprovalResult = () =>
  import(
    /* webpackChunkName: "PreApprovalResult" */ '@/views/PreApprovalResult.vue'
  );
const PostApprovalStep1 = () =>
  import(
    /* webpackChunkName: "PostApprovalStep1" */ '@/views/PostApprovalStep1.vue'
  );
const UdyamVerification = () =>
  import(
    /* webpackChunkName: "UdyamVerification" */ '@/views/UdyamVerification.vue'
  );
const UdyamOtpVerification = () =>
  import(
    /* webpackChunkName: "UdyamOtpVerification" */ '@/views/UdyamOtpVerification.vue'
  );
const UdyamList = () =>
  import(
    /* webpackChunkName: "UdyamList" */ '@/views/UdyamList.vue'
  );
const PostApprovalStep2 = () =>
  import(
    /* webpackChunkName: "PostApprovalStep2" */ '@/views/PostApprovalStep2.vue'
  );
const CreditStatement = () =>
  import(
    /* webpackChunkName: "CreditStatement" */ '@/views/CreditStatement.vue'
  );
const RewardSchemes = () =>
  import(
    /* webpackChunkName: "RewardSchemes" */ '@/views/RewardSchemes.vue'
  );
const RewardSchemeDetails = () =>
  import(
    /* webpackChunkName: "RewardSchemeDetails" */ '@/views/RewardSchemeDetails.vue'
  );
const downloadStatement = () =>
  import(
    /* webpackChunkName: "downloadStatement" */ '@/views/downloadStatement.vue'
  );
const LoanAgreementDocument = () =>
  import(
    /* webpackChunkName: "LoanAgreementDocument" */ '@/views/LoanAgreementDocument.vue'
  );
const DocumentsData = () =>
  import(
    /* webpackChunkName: "DocumentsData" */ '@/views/DocumentsData.vue'
  );
const RedirectToMandate = () =>
  import(
    /* webpackChunkName: "RedirectToMandate" */ '@/views/RedirectToMandate.vue'
  );
const Setting = () =>
  import(
    /* webpackChunkName: "Setting" */ '@/views/Setting.vue'
  );
const VideoVerificationResult = () =>
  import(
    /* webpackChunkName: "VideoVerificationResult" */ '@/views/VideoVerificationResult.vue'
  );
const OnBoardingLayout = () =>
  import(
    /* webpackChunkName: "OnBoardingLayout" */ '@/views/OnBoardingLayout.vue'
  );
const NotServiceArea = () =>
  import(
    /* webpackChunkName: "NotServiceArea" */ '@/views/NotServiceArea.vue'
  );
  const NotificationView = () =>
    import(
      /* webpackChunkName: "NotificationView" */ '@/views/NotificationView.vue'
    );
const AadhaarESignSuccess = () =>
  import(
    /* webpackChunkName: "AadhaarESignSuccess" */ '@/views/AadhaarESignSuccess.vue'
  );
const PersonalAddress = () =>
  import(
    /* webpackChunkName: "PersonalAddress" */ '@/views/PersonalAddress.vue'
  );
const GuarantorOnBoardingLayout = () =>
  import(
    /* webpackChunkName: "GuarantorOnBoardingLayout" */ '@/views/GuarantorOnBoardingLayout.vue'
  );
const GuarantorDetails = () =>
  import(
    /* webpackChunkName: "GuarantorDetails" */ '@/views/GuarantorDetails.vue'
  );
const GuarantorVerificationDetails = () =>
  import(
    /* webpackChunkName: "GuarantorVerificationDetails" */ '@/views/GuarantorVerificationDetails.vue'
  );
const GuarantorPanVerification = () =>
  import(
    /* webpackChunkName: "GuarantorPanVerification" */ '@/views/GuarantorPanVerification.vue'
  );
const GuarantorKyc = () =>
  import(
    /* webpackChunkName: "GuarantorKyc" */ '@/views/GuarantorKyc.vue'
  );

const routes = [
  {
    path: '/login',
    name: 'Login',
    component: Login,
    meta: {
      requiresAuth: false
    },
    children: [
      {
        path: '',
        redirect: { name: 'Mobile No' }
      },
      {
        name: 'Mobile No',
        path: 'mobile-no',
        component: MobileNo,
        meta: {
          requiresAuth: false
        },
      },
      {
        path: 'verify-otp',
        name: 'Verify Otp',
        component: VerifyOtp,
        meta: {
          requiresAuth: false
        }
      }
    ]
  },
  {
    path: '/signup',
    name: 'Signup',
    component: Signup,
    meta: {
      requiresAuth: true
    },
    children: [
      // {
      //   path: 'tnc',
      //   name: 'Tnc',
      //   component: Tnc,
      //   meta: {
      //     requiresAuth: true,
      //     displayName: 'Terms & Conditions',
      //     allowedStatus: ['initiated'],
      //     transitionName: 'slide'
      //   }
      // },
      // {
      //   path: 'serviceability-check',
      //   name: 'Serviceability Check',
      //   component: ServiceabilityCheck,
      //   meta: {
      //     requiresAuth: true,
      //     displayName: 'Serviceability Check',
      //     allowedStatus: ['initiated'],
      //     transitionName: 'slide'
      //   }
      // },
      // {
      //   path: 'kyc-selection',
      //   name: 'KYC Selection',
      //   component: KycSelection,
      //   meta: {
      //     requiresAuth: true,
      //     displayName: 'KYC Selection',
      //     allowedStatus: ['fosSkipped', 'fosAssigned', 'serviceabilityChecked'],
      //     transitionName: 'slide'
      //   }
      // },
      // {
      //   path: 'info',
      //   name: 'Referral Info',
      //   component: ReferralInfo,
      //   meta: {
      //     requiresAuth: true,
      //     allowedStatus: ['tncAccepted'],
      //     transitionName: 'slide'
      //   }
      // },
      // {
      //   path: 'selfie',
      //   name: 'Selfie',
      //   component: Selfie,
      //   meta: {
      //     requiresAuth: true,
      //     displayName: 'Upload Selfie',
      //     allowedStatus: ['addressProofIdNumberUpdated'],
      //     transitionName: 'slide'
      //   }
      // },
      // {
      //   path: 'onboarding-type',
      //   name: 'Onboarding Type',
      //   component: OnboardingType,
      //   meta: {
      //     requiresAuth: true,
      //     displayName: 'FOS Selection',
      //     allowedStatus: ['tncAccepted'],
      //     transitionName: 'slide'
      //   }
      // },
      // {
      //   path: 'personal-profile-1',
      //   name: 'Personal Profile Step 1',
      //   component: PersonalProfileStep1,
      //   meta: {
      //     requiresAuth: true,
      //     displayName: 'Upload Personal ID',
      //     allowedStatus: ['addressProofAsPerIdUploaded'],
      //     transitionName: 'slide'
      //   }
      // },
      // {
      //   path: 'personal-profile-1/edit',
      //   name: 'Edit Personal Profile Step 1',
      //   component: PersonalProfileStep1,
      //   meta: {
      //     requiresAuth: true,
      //     displayName: 'Edit Personal Profile',
      //     isEdit: true,
      //     allowedStatus: [],
      //     transitionName: 'slide'
      //   }
      // },
      // {
      //   path: 'personal-profile-2',
      //   name: 'Personal Profile Step 2',
      //   component: PersonalProfileStep2,
      //   meta: {
      //     requiresAuth: true,
      //     displayName: 'Personal Profile',
      //     allowedStatus: ['addressProofIdNumberUpdated'],
      //     transitionName: 'slide'
      //   }
      // },
      // {
      //   path: 'personal-profile-2/edit',
      //   name: 'Edit Personal Profile Step 2',
      //   component: PersonalProfileStep2,
      //   meta: {
      //     requiresAuth: true,
      //     displayName: 'Edit Personal Profile',
      //     isEdit: true,
      //     allowedStatus: [],
      //     transitionName: 'slide'
      //   }
      // },
      // {
      //   path: 'business-registration',
      //   name: 'Business Registration',
      //   component: BusinessRegistration,
      //   meta: {
      //     requiresAuth: true,
      //     displayName: 'Business Registration',
      //     allowedStatus: ['personalInfoUpdated'],
      //     transitionName: 'slide'
      //   }
      // },
      // {
      //   path: 'business-registration/edit',
      //   name: 'Edit Business Registration',
      //   component: BusinessRegistration,
      //   meta: {
      //     requiresAuth: true,
      //     displayName: 'Edit Business Registration Proof',
      //     isEdit: true,
      //     allowedStatus: [],
      //     transitionName: 'slide'
      //   }
      // },
      // {
      //   path: 'business-profile',
      //   name: 'Business Profile',
      //   component: BusinessProfile,
      //   meta: {
      //     requiresAuth: true,
      //     displayName: 'Business Profile',
      //     allowedStatus: ['businessRegistrationDetailsUpdated', 'businessRegistrationInfoUpdated'],
      //     transitionName: 'slide'
      //   }
      // },
      // {
      //   path: 'business-profile/edit',
      //   name: 'Edit Business Profile',
      //   component: BusinessProfile,
      //   meta: {
      //     requiresAuth: true,
      //     displayName: 'Edit Business Profile',
      //     isEdit: true,
      //     allowedStatus: [],
      //     transitionName: 'slide'
      //   }
      // },
      // {
      //   path: 'view-profile',
      //   name: 'View Profile',
      //   component: ViewProfile,
      //   meta: {
      //     requiresAuth: true,
      //     displayName: 'Review Application',
      //     allowedStatus: ['marketplaceDocumentUploaded', 'bankStatementSkipped'],
      //     transitionName: 'slide'
      //   },
      // },
    ]
  },
  {
    path: '/guarantor',
    name: 'guarantor On Boarding Layout',
    component: GuarantorOnBoardingLayout,
    meta: {
      requiresAuth: true
    },
    children: [
      {
        path: '/guarantor-pan-verification',
        name: 'Guarantor Pan Verification',
        component: GuarantorPanVerification,
        meta: {
          requiresAuth: true,
          displayName: 'Guarantor Pan Verification',
          allowedStatus: ['initiated'],
        }
      },
      {
        path: '/guarantor-kyc',
        name: 'Guarantor Kyc',
        component: GuarantorKyc,
        meta: {
          requiresAuth: true,
          displayName: 'Guarantor Kyc',
          allowedStatus: ['initiated'],
        }
      },
      {
        path: '/guarantor-verification-details',
        name: 'Guarantor Verification Details',
        component: GuarantorVerificationDetails,
        meta: {
          requiresAuth: true,
          displayName: 'Guarantor Pan Verification',
          allowedStatus: ['initiated'],
        }
      },
      {
        path: 'guarantor-details',
        name: 'Guarantor Details',
        component: GuarantorDetails,
        meta: {
          requiresAuth: true,
          displayName: 'Guarantors Details',
          allowedStatus: [
            "readyForOps",
          ],
          transitionName: 'slide'
        }
      },
      {
        path: 'kyc-failure',
        name: 'Guarantor Kyc Failure',
        component: KycFailure,
        meta: {
          requiresAuth: true,
          allowedStatus: ['initiated'],
          transitionName: 'slide'
        }
      },
      {
        path: 'kyc-success',
        name: 'Guarantor KYC Success',
        component: KycSuccess,
        meta: {
          requiresAuth: true,
          allowedStatus: ['initiated'],
          transitionName: 'slide'
        }
      },
      {
        path: 'guarantor-verified',
        name: 'Guarantor Verified',
        component: KycSuccess,
        meta: {
          requiresAuth: true,
          allowedStatus: ['initiated'],
          transitionName: 'slide'
        }
      },
      {
        path: 'guarantor-not-verified',
        name: 'Guarantor Not Verified',
        component: KycFailure,
        meta: {
          requiresAuth: true,
          allowedStatus: ['initiated'],
          transitionName: 'slide'
        }
      },
    ]
  },
  {
    path: '/signup',
    name: 'On Boarding Layout',
    component: OnBoardingLayout,
    meta: {
      requiresAuth: true
    },
    children: [
      {
        path: 'pre-approval',
        name: 'Pre Approval',
        component: PrePostApprovalLayout,
        meta: {
          requiresAuth: true,
          displayName: 'Pre Approval',
          transitionName: 'slide',
          allowedStatus: ['initiated'],
        },
        children: [
          {
            path: '',
            redirect: { name: 'Pre Approval Step 1' }
          },
          {
            name: 'Pre Approval Step 1',
            path: 'step-1',
            component: PreApprovalStep1,
            meta: {
              requiresAuth: true,
              displayName: 'Personal Details',
              transitionName: 'slide',
              allowedStatus: ['initiated'],
              totalSteps: 4,
              currentStep: 1,
              showRewardsBanner: true
            }
          },
          {
            name: 'Edit Pre Approval Step 1',
            path: 'edit/step-1',
            component: PreApprovalStep1,
            meta: {
              requiresAuth: true,
              displayName: 'Personal Details',
              transitionName: 'slide',
              allowedStatus: ['initiated'],
              isEdit: true
            }
          },
          {
            name: 'Pre Approval KYC Selection',
            path: 'kyc',
            component: PreApprovalKycSelection,
            meta: {
              requiresAuth: true,
              displayName: 'KYC',
              transitionName: 'slide',
              allowedStatus: ['initiated'],
              totalSteps: 4,
              currentStep: 2,
              showRewardsBanner: true
            }
          },
          {
            name: 'Pre Approval Step 2',
            path: 'step-2',
            component: PreApprovalStep2,
            meta: {
              requiresAuth: true,
              displayName: 'KYC',
              transitionName: 'slide',
              allowedStatus: ['initiated'],
              totalSteps: 4,
              currentStep: 2,
              showRewardsBanner: true
            }
          },
          {
            name: 'Edit Pre Approval Step 2',
            path: 'edit/step-2',
            component: PreApprovalStep2,
            meta: {
              requiresAuth: true,
              displayName: 'KYC',
              transitionName: 'slide',
              allowedStatus: ['initiated'],
              isEdit: true
            }
          },
          {
            name: 'Pre Approval Step 3',
            path: 'step-3',
            component: PreApprovalStep3,
            meta: {
              requiresAuth: true,
              displayName: 'Business Profile',
              transitionName: 'slide',
              allowedStatus: ['initiated'],
              totalSteps: 4,
              currentStep: 3,
              showRewardsBanner: true
            }
          },
          {
            name: 'Edit Pre Approval Step 3',
            path: 'edit/step-3',
            component: PreApprovalStep3,
            meta: {
              requiresAuth: true,
              displayName: 'Business Profile',
              transitionName: 'slide',
              allowedStatus: ['initiated'],
              isEdit: true
            }
          },
          {
            name: 'Pre Approval Review',
            path: 'review',
            component: PreApprovalReview,
            meta: {
              requiresAuth: true,
              displayName: 'Review Application',
              transitionName: 'slide',
              allowedStatus: ['initiated'],
            }
          },
          {
            name: 'Personal Address',
            path: 'personal-address',
            component: PersonalAddress,
            meta: {
              requiresAuth: true,
              displayName: 'Personal Address',
              transitionName: 'slide',
              allowedStatus: ['initiated'],
            }
          },
        ]
      },
      {
        path: 'post-approval',
        name: 'Post Approval',
        component: PrePostApprovalLayout,
        meta: {
          requiresAuth: true,
          displayName: 'Post Approval',
          transitionName: 'slide',
          allowedStatus: ['initiated'],
        },
        children: [
          {
            path: '',
            redirect: { name: 'Post Approval Step 1' }
          },
          {
            name: 'Post Approval Step 1',
            path: 'step-1',
            component: PostApprovalStep1,
            meta: {
              requiresAuth: true,
              displayName: 'eMandate/NACH Registration',
              transitionName: 'slide',
              allowedStatus: ['initiated'],
              totalSteps: 4,
              currentStep: 4,
              showRewardsBanner: true
            }
          },
          {
            name: 'Post Approval Step 2',
            path: 'step-2',
            component: PostApprovalStep2,
            meta: {
              requiresAuth: true,
              displayName: 'NACH Mandate',
              transitionName: 'slide',
              allowedStatus: ['initiated', 'readyForOps'],
              totalSteps: 4,
              currentStep: 4,
              showRewardsBanner: true
            },
            children: [
              {
                path: 'nach-success',
                name: 'NACH Success',
                component: NACHSuccess,
                meta: {
                  requiresAuth: true,
                  displayName: '',
                  allowedStatus: ['emandatePending', 'nachDownloaded', 'emandateRegistered', 'emandateFailed', 'documentUploaded', 'readyForOps', 'opsApproved', 'nbfcApproved'],
                  transitionName: 'slide'
                },
              },

            ]
          },
        ]
      },
      {
        name: 'Pre Approval Result',
        path: 'result',
        component: PreApprovalResult,
        meta: {
          requiresAuth: true,
          displayName: '',
          transitionName: 'slide',
          allowedStatus: ['initiated'],
        }
      },
      {
        name: 'Pre Approval Congratulations',
        path: 'congratulations',
        component: PreApprovalCongratulations,
        meta: {
          requiresAuth: true,
          displayName: '',
          transitionName: 'slide',
          allowedStatus: ['initiated'],
        }
      },
      {
        path: ':action/link-accounts',
        name: 'Link Accounts',
        component: LinkAccounts,
        meta: {
          requiresAuth: true,
          displayName: 'Link Supplier Account',
          allowedStatus: ['marketplaceDocumentUploadInProgress', 'opsApproved', 'readyForOps', 'approved',
            'nachUploaded',
            'nbfcApproved',
            'offerSelected',
            'bankDetailsUpdated',
            'chequeUploaded',
            'documentUploadInProgress',
            'documentUploaded',
            'emandatePending',
            'nachDownloaded', 'videoVerified'],
          transitionName: 'slide'
        }
      },
      {
        path: 'linked-accounts',
        name: 'Linked Accounts',
        component: LinkedAccounts,
        meta: {
          requiresAuth: true,
          displayName: 'Linked Suppliers',
          allowedStatus: ['marketplaceDocumentUploadInProgress', 'opsApproved', 'readyForOps', 'approved',
            'nachUploaded',
            'nbfcApproved',
            'offerSelected',
            'bankDetailsUpdated',
            'chequeUploaded',
            'documentUploadInProgress',
            'documentUploaded',
            'emandatePending',
            'nachDownloaded',
          ],
          transitionName: 'slide'
        }
      },
      {
        path: 'additional-info',
        name: 'Additional Info',
        component: AdditionalInfo,
        meta: {
          requiresAuth: true,
          displayName: 'GSTIN Verification',
          allowedStatus: [
            "initiated",
            "tncAccepted",
            "fosSkipped",
            "fosAssigned",
            "addressProofAsPerIdUploaded",
            "addressProofIdNumberUpdated",
            "personalInfoUpdated",
            "businessRegistrationDetailsUpdated",
            "businessInfoUpdated",
            "marketplaceDocumentUploadInProgress",
            "marketplaceDocumentUploaded",
            "croReview",
            "bankDetailsUpdated",
            "emandatePending",
            "bankStatementUploaded",
            "documentUploaded",
            "approved",
            "videoVerified",
            "offerSelected",
            "documentUploadInProgress",
            "questionnairePending",
            "questionnaireSubmitted",
            "nachUploaded",
            "nachDownloaded",
            "nbfcApproved",
            "opsApproved",
            "readyForOps",
            "selfieUploaded",
            "bankStatementSkipped",
            "manualBankStatementUploaded",
            "businessRegistrationDetailsSkipped",
            "digiLockerVerified",
            "chequeUploaded",
            "serviceabilityChecked"
          ],
          transitionName: 'slide'
        }
      },
      {
        path: 'video-verification',
        alias: 'video-verification-signup',
        name: 'Video Verification',
        component: VideoVerification,
        meta: {
          requiresAuth: true,
          displayName: 'Video Verification',
          allowedStatus: ['offerSelected'],
          transitionName: 'slide'
        },
      },
      {
        path: 'bank-details',
        name: 'Bank Details',
        component: BankDetails,
        meta: {
          requiresAuth: true,
          displayName: 'Bank Details',
          allowedStatus: ['chequeUploaded', 'readyForOps',
            'opsApproved', 'offerSelected'
          ],
          transitionName: 'slide'
        }
      },
      {
        path: 'upload-documents',
        name: 'Upload Documents',
        component: UploadDocuments,
        meta: {
          requiresAuth: true,
          displayName: 'Upload Documents',
          allowedStatus: ['bankDetailsUpdated', 'documentUploadInProgress', 'readyForOps', 'opsApproved'],
          transitionName: 'slide'
        }
      },
      {
        path: 'additional-documents',
        name: 'Additional Documents',
        component: AdditionalDocuments,
        meta: {
          requiresAuth: true,
          displayName: 'Additional Documents',
          allowedStatus: ['documentUploadInProgress', 'readyForOps', 'bankDetailsUpdated', 'opsApproved'],
          transitionName: 'slide'
        }
      },
      {
        path: 'dual-name-declaration',
        name: 'Dual Name Declaration',
        component: DualNameDeclaration,
        meta: {
          requiresAuth: true,
          displayName: 'Dual Name Declaration',
          allowedStatus: ['bankDetailsUpdated', 'documentUploadInProgress', 'readyForOps', 'opsApproved'],
          transitionName: 'slide'

        }
      },
      {
        path: 'dual-dob-declaration',
        name: 'Dual Dob Declaration',
        component: DualDobDeclaration,
        meta: {
          requiresAuth: true,
          displayName: 'Dual Dob Declaration',
          allowedStatus: ['bankDetailsUpdated', 'documentUploadInProgress', 'readyForOps', 'opsApproved'],
          transitionName: 'slide'
        }
      },
      {
        path: 'mandate',
        name: 'Mandate',
        component: Mandate,
        meta: {
          requiresAuth: true,
          displayName: 'NACH/eMandate',
          allowedStatus: ['emandatePending', 'nachDownloaded', 'emandateRegistered', 'emandateFailed', 'documentUploaded', 'readyForOps', 'opsApproved', 'nbfcApproved'],
          transitionName: 'slide'
        },
      },
      {
        path: 'redirect-mandate',
        name: 'Redirect To Mandate',
        component: RedirectToMandate,
        meta: {
          requiresAuth: true,
          transitionName: 'slide',
          allowedStatus: [
            'fosSkipped',
            'offerSelected',
            'digiLockerVerified',
            'personalInfoUpdated',
            'tncAccepted',
            'initiated',
            'emandatePending',
            'nachDownloaded',
            'emandateRegistered',
            'emandateFailed',
            'documentUploaded',
            'readyForOps',
            'opsApproved',
            'nbfcApproved'
          ],
        }
      },
      {
        path: 'nach-mandate',
        name: 'NACH Mandate',
        component: NachMandate,
        meta: {
          requiresAuth: true,
          displayName: 'NACH Mandate',
          allowedStatus: ['emandatePending', 'nachDownloaded', 'emandateRegistered', 'emandateFailed', 'documentUploaded', 'readyForOps', 'opsApproved', 'nbfcApproved'],
          transitionName: 'slide'
        }
      },
      {
        path: 'bank-statement',
        name: 'Bank Statement',
        component: BankStatement,
        meta: {
          requiresAuth: true,
          displayName: 'Bank Statement',
          allowedStatus: ['marketplaceDocumentUploaded', 'opsApproved', 'approved', 'readyForOps', 'opsApproved', 'nbfcApproved'],
          transitionName: 'slide'
        }
      },
      {
        path: 'questionnaire',
        name: 'Questionnaire',
        component: Questionnaire,
        meta: {
          requiresAuth: true,
          displayName: 'Questionnaire',
          allowedStatus: ['questionnairePending'],
          transitionName: 'slide'
        }
      },
      {
        path: 'success',
        name: 'Signup Success',
        component: Success,
        meta: {
          requiresAuth: true,
          displayName: undefined,
          allowedStatus: ['approved'],
          transitionName: 'slide'
        }
      },
      {
        path: 'loan-agreement',
        name: 'Loan Agreement',
        component: LoanAgreement,
        meta: {
          requiresAuth: true,
          displayName: 'Loan Agreement',
          allowedStatus: ['nachUploaded', 'readyForOps', 'opsApproved', 'emandatePending'],
          transitionName: 'slide'
        }
      },
      {
        path: 'loan-activated',
        name: 'Loan Auto Activation',
        component: LoanAutoActivation,
        meta: {
          requiresAuth: true,
          allowedStatus: ['readyForOps', 'opsApproved'],
          transitionName: 'slide'
        }
      },
      {
        path: 'failure',
        name: 'Signup Failure',
        component: Failure,
        meta: {
          requiresAuth: false,
          transitionName: 'slide'
        }
      },
      {
        path: 'kyc-failure',
        name: 'KYC Failure',
        component: KycFailure,
        meta: {
          requiresAuth: true,
          allowedStatus: ['fosSkipped', 'serviceabilityChecked', 'addressProofAsPerIdUploaded', 'digiLockerVerified', 'personalInfoUpdated'],
          transitionName: 'slide'
        }
      },
      {
        path: 'kyc-success',
        name: 'KYC Success',
        component: KycSuccess,
        meta: {
          requiresAuth: true,
          allowedStatus: ['fosSkipped', 'serviceabilityChecked', 'addressProofAsPerIdUploaded', 'digiLockerVerified', 'personalInfoUpdated'],
        }
      },
      {
        path: 'kyc-result',
        name: 'KYC Result',
        component: KycResult,
        meta: {
          requiresAuth: true,
          allowedStatus: ['fosSkipped', 'serviceabilityChecked', 'addressProofAsPerIdUploaded', 'digiLockerVerified', 'personalInfoUpdated'],
          transitionName: 'slide'
        }
      },
      {
        path: 'discrepancy',
        name: 'Application Discrepancy',
        component: ApplicationDiscrepancy,
        meta: {
          requiresAuth: true,
          allowedStatus: ['readyForOps'],
          transitionName: 'slide',
          displayName: 'Application Discrepancy',
        },
      },
      {
        path: '/signup/mandate/success',
        name: 'Mandate Success',
        component: MandateSuccess,
        meta: {
          requiresAuth: true,
          displayName: '',
          allowedStatus: ['emandatePending', 'nachDownloaded', 'emandateRegistered', 'emandateFailed', 'documentUploaded', 'readyForOps', 'opsApproved', 'nbfcApproved'],
          transitionName: 'slide'
        },
      },
      {
        path: '/signup/mandate/failure',
        name: 'Mandate Failure',
        component: MandateFailure,
        meta: {
          requiresAuth: true,
          displayName: '',
          allowedStatus: ['emandatePending', 'nachDownloaded', 'emandateRegistered', 'emandateFailed', 'documentUploaded', 'readyForOps', 'opsApproved', 'nbfcApproved'],
          transitionName: 'slide'
        },
      },
      {
        path: '/signup/mandate/pending',
        name: 'Mandate Pending',
        component: MandatePending,
        meta: {
          requiresAuth: true,
          displayName: '',
          allowedStatus: ['emandatePending', 'nachDownloaded', 'emandateRegistered', 'emandateFailed', 'documentUploaded', 'readyForOps', 'opsApproved', 'nbfcApproved'],
          transitionName: 'slide'
        },
      },
      {
        path: '/signup/mandate/completed',
        name: 'Mandate Already Completed',
        component: MandateAlreadyCompleted,
        meta: {
          requiresAuth: true,
          displayName: '',
          allowedStatus: ['emandatePending', 'nachDownloaded', 'emandateRegistered', 'emandateFailed', 'documentUploaded', 'readyForOps', 'opsApproved', 'nbfcApproved'],
          transitionName: 'slide'
        },
      },
    ]
  },
  {
    path: '',
    name: 'Home',
    component: Home,
    meta: {
      requiresAuth: true
    },
    children: [
      {
        path: '',
        redirect: '/dashboard'
      },
      {
        path: '/dashboard',
        name: 'Dashboard',
        component: Dashboard,
        meta: {
          requiresAuth: true,
          displayName: 'Dashboard'
        },
        children: [
          {
            path: 'notification',
            name: 'notification view',
            component: NotificationView,
            meta: {
              requiresAuth: true,
              showSidebar: true,
              displayName: 'Notification',
            },
          },
          {
            path: 'payment-methods',
            name: 'Payment Methods',
            component: PaymentMethods,
            meta: {
              requiresAuth: true,
              showSidebar: true,
              displayName: 'Make Payment'
            },
          },
          {
            path: 'processing-fee',
            name: 'Processing Fee',
            component: ProcessingFee,
            meta: {
              requiresAuth: true,
              showSidebar: true,
              displayName: 'Processing Fee'
            },
          },
          {
            path: 'processing-fee-result',
            name: 'Processing Fee Result',
            component: ProcessingFeeResult,
            meta: {
              requiresAuth: true,
              showSidebar: true,
              displayName: 'Processing Fee Result'
            },
          },
          {
            path: 'payment-success',
            name: 'Payment Success',
            component: PaymentSuccess,
            meta: {
              requiresAuth: true,
              showSidebar: true,
              displayName: 'Payment Success'
            },
          },
          {
            path: 'payment-failure',
            name: 'Payment Failure',
            component: PaymentFailure,
            meta: {
              requiresAuth: true,
              showSidebar: true,
              displayName: 'Payment Failure'
            },
          },
          {
            path: 'details',
            name: 'Home Offer Details',
            component: OfferDetails,
            meta: {
              requiresAuth: true,
              displayName: 'Offer Details',
              showSidebar: true
            }
          },
          {
            path: 'pay-now',
            name: 'Pay Now',
            component: PayNow,
            meta: {
              requiresAuth: true,
              showSidebar: true,
              displayName: 'Pay Now'

            },
          },
          {
            path: 'transaction-details',
            name: 'Transaction Details',
            component: TransactionDetails,
            meta: {
              requiresAuth: true,
              showSidebar: true,
              displayName: 'Transaction Details'

            },
          },
          {
            path: 'transaction-summary',
            name: 'Transaction Summary',
            component: TransactionSummary,
            meta: {
              requiresAuth: true,
              showSidebar: true
            },
          }
        ]
      },
      {
        path: '/loan-offers',
        name: 'Loan Offers',
        component: LoanOffers,
        meta: {
          requiresAuth: true,
          displayName: 'Loan Offers'

        }
      },
      {
        path: '/suppliers',
        name: 'Suppliers',
        component: Suppliers,
        meta: {
          requiresAuth: true,
          displayName: 'Suppliers'
        },
        children: [
          {
            path: 'select',
            name: 'Select Supplier',
            component: SelectSupplier,
            meta: {
              requiresAuth: true,
              showSidebar: true,
              displayName: 'Select Supplier'
            },
            children: []
          },
          {
            path: 'add',
            name: 'Add Supplier',
            component: AddSupplier,
            meta: {
              requiresAuth: true,
              showSidebar: true,
              displayName: 'Add Supplier'
            }
          },
          {
            path: 'invite',
            name: 'Invite Supplier',
            component: InviteSupplier,
            meta: {
              requiresAuth: true,
              showSidebar: true,
              displayName: 'Invite Supplier'
            }
          },
          {
            path: 'send-invite',
            name: 'Send Invite Supplier',
            component: SendInviteSupplier,
            meta: {
              requiresAuth: true,
              showSidebar: true,
              displayName: 'Invite Supplier'
            }
          },
          {
            path: 'quick-payment',
            name: 'Quick Payment',
            component: QuickPayment,
            meta: {
              requiresAuth: true,
              showSidebar: true,
              displayName: 'Quick payment'
            },
          },
          {
            path: 'upload-invoice',
            name: 'Upload Invoice',
            component: UploadInvoice,
            meta: {
              requiresAuth: true,
              showSidebar: true,
              displayName: 'Upload Invoice'
            },
          },
          {
            path: 'make-invoice-payment',
            name: 'Make Invoice Payment',
            component: MakeInvoicePayment,
            meta: {
              requiresAuth: true,
              showSidebar: true,
              displayName: 'Make Payment'

            },
          },
          {
            path: 'quick-payment-otp',
            name: 'Quick Payment OTP',
            component: QuickPaymentOTP,
            meta: {
              requiresAuth: true,
              showSidebar: true,
              displayName: 'Quick payment'

            },
          },
          {
            path: 'quick-payment-success',
            name: 'Quick Payment Success',
            component: QuickPaymentSuccess,
            meta: {
              requiresAuth: true,
              showSidebar: true,
              displayName: 'Make payment'

            },
          },
          {
            path: 'quick-payment-fail',
            name: 'Quick Payment Fail',
            component: QuickPaymentFail,
            meta: {
              requiresAuth: true,
              showSidebar: true,
              displayName: 'Make payment'

            },
          },
        ]
      },
      {
        path: '/supplier/:id?',
        component: SupplierParent,
        children: [
          {
            path: 'payment-history',
            name: 'Supplier Payment History',
            component: SupplierPaymentHistory,
            meta: {
              requiresAuth: true,
              displayName: 'Payment History'
            },
            children: [
              {
                path: 'payment-methods',
                name: 'Supplier Payment Methods',
                component: PaymentMethods,
                meta: {
                  requiresAuth: true,
                  showSidebar: true,
                  displayName: 'Make Payment',
                  isSupplierFlow: true
                },
              },
              {
                path: 'payment-success',
                name: 'Supplier Payment Success',
                component: PaymentSuccess,
                meta: {
                  requiresAuth: true,
                  showSidebar: true,
                  displayName: 'Payment Success',
                  isSupplierFlow: true

                },
              },
              {
                path: 'payment-failure',
                name: 'Supplier Payment Failure',
                component: PaymentFailure,
                meta: {
                  requiresAuth: true,
                  showSidebar: true,
                  displayName: 'Payment Failure',
                  isSupplierFlow: true

                }
              },
              {
                path: 'pay-now',
                name: 'Supplier Pay Now',
                component: PayNow,
                meta: {
                  requiresAuth: true,
                  showSidebar: true,
                  displayName: 'Pay Now',
                  isSupplierFlow: true

                },
              },
              {
                path: 'transaction-details',
                name: 'Supplier Transaction Details',
                component: TransactionDetails,
                meta: {
                  requiresAuth: true,
                  showSidebar: true,
                  displayName: 'Transaction Details',
                  isSupplierFlow: true
                },
              },
              {
                path: 'transaction-summary',
                name: 'Supplier Transaction Summary',
                component: TransactionSummary,
                meta: {
                  requiresAuth: true,
                  showSidebar: true,
                  isSupplierFlow: true
                },
              },
            ]
          },
          {
            path: 'pending-payments',
            name: 'Supplier Pending Payments',
            component: SupplierPendingPayments,
            meta: {
              requiresAuth: true,
              displayName: 'Pending Payments'
            },
            children: [
              {
                path: 'details',
                name: 'Pending Payment Details',
                component: PendingPaymentDetails,
                meta: {
                  requiresAuth: true,
                  showSidebar: true,
                  displayName: 'Transaction Details',
                  isSupplierFlow: true
                },
              },
              {
                path: 'clear-payment-due',
                name: 'Clear Payment Due',
                component: ClearPaymentDue,
                meta: {
                  requiresAuth: true,
                  showSidebar: true,
                  displayName: 'Make Payment',
                  // isSupplierFlow: true
                },
              }
            ]
          },
          {
            path: 'pending-requests',
            name: 'Pending Requests',
            component: PendingRequests,
            meta: {
              requiresAuth: true,
              displayName: 'Pending Requests'
            }
          },
        ]
      },
      {
        path: '/offers',
        name: 'Offers',
        component: Offers,
        meta: {
          requiresAuth: true,
          displayName: 'Offers'
        },
        children: [
          {
            path: 'details',
            name: 'Offer Details',
            component: OfferDetails,
            meta: {
              requiresAuth: true,
              displayName: 'Offer Details'
            }
          },
        ]
      },
      {
        path: '/my-profile',
        name: 'My Profile',
        component: MyProfile,
        meta: {
          requiresAuth: true,
          displayName: 'My Profile'
        },
      },
      {
        path: '/setting',
        name: 'Setting',
        component: Setting,
        meta: {
          requiresAuth: true,
          displayName: 'Setting'
        },
      },
      {
        path: 'loan-agreement/document',
        name: 'Loan Agreement Document',
        component: LoanAgreementDocument,
        meta: {
          requiresAuth: true,
          displayName: 'Loan Agreement(s)',
          transitionName: 'slide'
        },
      },
      {
        path: 'documents',
        name: 'Documents Data',
        component: DocumentsData,
        meta: {
          requiresAuth: true,
          displayName: 'Documents',
          transitionName: 'slide'
        },
        redirect: {
          name: 'My Profile Documents'
        },
        children: [
          {
            name: 'My Profile Documents',
            path: '',
            component: UploadDocuments,
            meta: {
              requiresAuth: true,
              displayName: 'My Profile'
            },
          }
        ]
      },
      {
        path: '/payment-history',
        name: 'Payment History',
        component: PaymentHistory,
        meta: {
          requiresAuth: true,
          displayName: 'Payment History'
        },

      },
      {
        path: '/rewards',
        name: 'Rewards',
        component: Rewards,
        meta: {
          requiresAuth: true,
          displayName: 'Rewards'
        },
        redirect: {
          name: 'Reward Statement',
        },
        children: [
          {
            path: 'statement',
            name: 'Reward Statement',
            component: RewardStatement,
            meta: {
              requiresAuth: true,
              displayName: 'Reward Statement'
            }
          },
          {
            path: 'schemes',
            name: 'Reward Schemes',
            component: RewardSchemes,
            meta: {
              requiresAuth: true,
              displayName: 'Reward Schemes'
            },
            children: [
              {
                path: ':id',
                name: 'Reward Scheme Details',
                component: RewardSchemeDetails,
                meta: {
                  requiresAuth: true,
                  displayName: 'Reward Scheme Details',
                  showSidebar: true
                }
              }
            ]
          }
        ]
      },
      {
        path: '/gstin-verification',
        name: 'GSTIN Verification',
        component: GSTINVerification,
        meta: {
          requiresAuth: true,
          displayName: 'My Profile'
        },
      },
      {
        path: '/credit-statement',
        name: 'Credit Statement',
        component: CreditStatement,
        meta: {
          requiresAuth: true,
          displayName: 'Credit Statement'
        },
        children: [
          {
            path: 'payment-methods',
            name: 'Credit Statement Payment Methods',
            component: PaymentMethods,
            meta: {
              requiresAuth: true,
              showSidebar: true,
              displayName: 'Make Payment',
              isCreditStatementFlow: true
            },
          },
          {
            path: 'payment-success',
            name: 'Credit Statement Payment Success',
            component: PaymentSuccess,
            meta: {
              requiresAuth: true,
              showSidebar: true,
              displayName: 'Payment Success',
              isCreditStatementFlow: true

            },
          },
          {
            path: 'payment-failure',
            name: 'Credit Statement Payment Failure',
            component: PaymentFailure,
            meta: {
              requiresAuth: true,
              showSidebar: true,
              displayName: 'Payment Failure',
              isCreditStatementFlow: true

            }
          },
          {
            path: 'pay-now',
            name: 'Credit Statement Pay Now',
            component: PayNow,
            meta: {
              requiresAuth: true,
              showSidebar: true,
              displayName: 'Pay Now',
              isCreditStatementFlow: true

            },
          },
          {
            path: 'transaction-details',
            name: 'Credit Statement Transaction Details',
            component: TransactionDetails,
            meta: {
              requiresAuth: true,
              showSidebar: true,
              displayName: 'Transaction Details',
              isCreditStatementFlow: true
            },
          },
          {
            path: 'transaction-summary',
            name: 'Credit Statement Transaction Summary',
            component: TransactionSummary,
            meta: {
              requiresAuth: true,
              showSidebar: true,
              isCreditStatementFlow: true
            },
          },
          {
            path: 'download-statement',
            name: 'Credit Statement download statement',
            component: downloadStatement,
            meta: {
              requiresAuth: true,
              showSidebar: true,
              displayName: 'Download Statement',
              isCreditStatementFlow: true
            },
          },
        ]

      },
      {
        path: '/refer-and-earn',
        name: 'Refer And Earn',
        component: ReferAndEarn,
        meta: {
          requiresAuth: true,
          displayName: 'Refer And Earn'

        }
      },
      {
        path: '/cards',
        name: 'My Cards',
        component: MyCards,
        meta: {
          requiresAuth: true,
          displayName: 'My Cards'

        }
      },
      {
        path: '/help',
        name: 'Help',
        meta: {
          requiresAuth: true,
        },
        beforeEnter: () => {
          window.location.href = 'https://epaylater.in/support.html';
        }
      },
    ]
  },
  {
    path: '/signup/loan-success',
    name: 'Loan Success',
    component: LoanSuccess,
    meta: {
      requiresAuth: true,
      allowedStatus: ['readyForOps', 'opsApproved'],
      transitionName: 'slide'
    }
  },
  {
    path: '/video-verification-result',
    name: 'Video Verification Result',
    component: VideoVerificationResult,
    meta: {
      requiresAuth: false,
      displayName: ''
    },
  },
  {
    path: '/loan-failure',
    name: 'Loan Failure',
    component: LoanFailure,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/:id/signup-under-review',
    name: 'Signup Under Review',
    component: SignupUnderReview,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/:documentName/upload-preview',
    name: 'Upload Preview',
    component: UploadPreview,
    meta: {
      requiresAuth: true,
      allowedStatus: ['bankDetailsUpdated', 'documentUploadInProgress', 'readyForOps', 'opsApproved']
    }
  },
  {
    path: '/:nbfcName/loan-details',
    name: 'Loan Details',
    component: LoanDetails,
    meta: {
      requiresAuth: true,
    }
  },
  {
    path: '/error-not-eligible',
    name: 'ErrorNotEligible',
    component: ErrorNotEligible,
    meta: {
      requiresAuth: false,
    },
  },
  {
    name: 'Udyam Verification',
    path: '/udyam-verification',
    component: UdyamVerification,
    meta: {
      requiresAuth: true,
      displayName: 'Udyam Verification',
      transitionName: 'slide',
      // allowedStatus: ['initiated'],
    },
  },
  {
    name: 'Udyam OTP Verification',
    path: '/udyam-otp-verification',
    component: UdyamOtpVerification,
    meta: {
      requiresAuth: true,
      displayName: 'Enter Udyam OTP',
      transitionName: 'slide',
      // allowedStatus: ['initiated'],
    },
  },
  {
    name: 'Udyam List',
    path: '/udyam-list',
    component: UdyamList,
    meta: {
      requiresAuth: true,
      displayName: 'Select Udyam',
      transitionName: 'slide',
      // allowedStatus: ['initiated'],
    },
  },
  {
    path: '/not-service-area',
    name: 'Not Service Area',
    component: NotServiceArea,
    meta: {
      requiresAuth: false,
    },
  },
  {
    path: '/:page(sign-up)',
    redirect: '/login'
  },
  {
    path: '/:page(home|mysuppliers|referandearn|notifications|how-it-works|scan-pay|addlinksupplier|invitesupplier|pendingrequests|epaycards|pendingbills)',
    redirect: '/dashboard'
  },
  {
    path: '/:page(myprofile)',
    redirect: '/my-profile'
  },
  {
    path: '/:page(mycredit-signup)',
    // redirect: '/signup/pre-approval'
    redirect: () => ({
      path: '/signup',
      query: {
        deeplink: "mycredit signup"
      }
    })
  },
  {
    path: '/:page(top-offers|offer-details)',
    redirect: '/offers'
  },
  {
    path: '/:page(profile-settings)',
    redirect: '/setting'
  },
  {
    path: '/:page(reward-points)',
    redirect: '/rewards/statement'
  },
  {
    path: '/:page(resolve-discrepancy)',
    redirect: '/signup/discrepancy'
  },
  {
    path: '/:page(mandate)',
    redirect: '/signup/post-approval'
  },
  {
    path: '/:page(paymenthistory)',
    redirect: '/payment-history'
  },
  {
    path: '/:page(bank-statement)',
    redirect: '/documents'
  },
  {
    path: '/:page(va-accounts)',
    redirect: () => ({
        path: '/signup/redirect-mandate',
        query: {
          mode: 'bank-transfers',
          redirectRouteName: 'My Profile',
          displayName: 'A/C details for bank transfers'
        }
      })
  },
  {
    name: 'Aadhaar ESign Success',
    path: '/aadhaar-esign-success',
    component: AadhaarESignSuccess,
  },
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
});
router.beforeEach((to, from, next) => {
  const isAuthenticated = localStorage.getItem('token') && /^[6-9][0-9]{9}/.test(localStorage.getItem('phone'));
  const isReferralFlow = JSON.parse(localStorage.getItem('isReferralFlow'));
  if (to.meta.requiresAuth && !isAuthenticated && typeof GenericEpaylater === 'undefined') {
    next({ name: 'Mobile No', query: { redirect: to.name, ...to.query } });
  } else if (typeof GenericEpaylater !== 'undefined') {
    // eslint-disable-next-line no-undef
    const android = GenericEpaylater || undefined;
    localStorage.setItem('token', android.userToken());
    localStorage.setItem('phone', android.userPhone());
    if (to.name === 'Mobile No' || to.name === 'Verify Otp') {
      next({ name: 'Dashboard', });
    } else {
      next();
    }
  } else if ((to.name === 'Mobile No' || to.name === 'Verify Otp') && isAuthenticated) {
    next({ name: isReferralFlow ? 'Signup' : 'Dashboard', });
  } else next();
});
export default router;
